import React, { useState, useRef, useEffect } from 'react';
import './Header.css';
import '../../assets/css/style.css';
import '../../assets/css/bootstrap.min.css';
import "../../assets/css/bootstrap-datetimepicker.min.css";
import '../../App.css'
import Navbar from '../Navbar/Navbar';
import Facilities from '../Facilities/Facilities';
import '../Facilities/Facilities.css';
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight,faClock, } from '@fortawesome/free-solid-svg-icons';
 
import { FaBookmark, FaCheckCircle } from 'react-icons/fa';
import { FaMapMarkerAlt,FaClock  } from 'react-icons/fa';
import NABH from '../NABH/NABH'; // Import the NABH component

// Import all images
import speciality01 from '../../assets/img/specialities/1.png';
import speciality02 from '../../assets/img/specialities/2.png';
import speciality03 from '../../assets/img/specialities/3.png';
import speciality04 from '../../assets/img/specialities/4.png';
import speciality05 from '../../assets/img/specialities/5.png';
import speciality06 from '../../assets/img/specialities/6.png';
import speciality07 from '../../assets/img/specialities/7.png';
import speciality08 from '../../assets/img/specialities/8.png';
import speciality09 from '../../assets/img/specialities/9.png';
import speciality10 from '../../assets/img/specialities/10.png';
import speciality11 from '../../assets/img/specialities/11.png';
import speciality12 from '../../assets/img/specialities/12.png';
import speciality13 from '../../assets/img/specialities/13.png';
import speciality14 from '../../assets/img/specialities/14.png';
import speciality15 from '../../assets/img/specialities/15.png';
import speciality16 from '../../assets/img/specialities/16.png';
import doctor01 from '../../assets/img/doctors/doctor-01.jpg';
import doctor02 from '../../assets/img/doctors/doctor-02.jpg';
import doctor03 from '../../assets/img/doctors/doctor-03.jpg';
import doctor04 from '../../assets/img/doctors/doctor-04.jpg';
import doctor05 from '../../assets/img/doctors/doctor-05.jpg';
import feature01 from '../../assets/img/features/feature-01.jpg';
import feature02 from '../../assets/img/features/feature-02.jpg';
import feature03 from '../../assets/img/features/feature-03.jpg';
import feature04 from '../../assets/img/features/feature-04.jpg';
import feature05 from '../../assets/img/features/feature-05.jpg';
import feature06 from '../../assets/img/features/feature-06.jpg';
import feature07 from '../../assets/img/facility.png';
import facility from "../../assets/img/features/facility-01.jpg"
import feature3 from "../../assets/img/features/facility-01.jpg"
import feature6 from "../../assets/img/features/facility-02.jpg"
import feature4 from "../../assets/img/features/facility-03.jpg"
import { Link } from "react-router-dom"; // Import Link for navigation
import { FaRupeeSign } from "react-icons/fa";

import maa from "./img/maaVoucher.jpg"
import esic from "./img/esic.png"
import star from "./img/Star_Health_and_Allied_Insurance.svg.png"
import aditya from "./img/aditya.jpg"
import apollo from "./img/apollo.jpg"
import ayushman from "./img/ayushman.png"
import RGHS from "./img/RGHS.png"
import govt from "./img/govt-employee.png"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import hitakrilogo from '../../assets/img/hitakrilogo.png';

import {
    faHeartPulse,
    faStethoscope,
    faBaby,
    faBell,
    faHeart,
    faUserShield,
    faBuilding,
    faCapsules,
} from "@fortawesome/free-solid-svg-icons";
import Footer from '../Footer/Footer';
import Reviews from '../reviews/Reviews';
import HomeGallery from '../HomeGallery/Homegallery';
import AchievementsSection from '../AchievementsSection/AchievementsSection';
import AvailableFeatures from '../Availablefeatures/Availablefeatures';
const awardsData = [
     { name: "Govt Employee", img: govt },
    { name: "RGHS", img: RGHS  },
    { name: "Ayushman Bharat", img: ayushman },
    { name: "Maa Voucher ", img: maa },
    { name: "ESIC", img: esic },
    { name: "Star Health", img: star },
     { name: "Aditya Birla", img: aditya },
     { name: "Apollo", img: apollo },

];

const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005';

const Header = () => {
    const slides = [
        { image: doctor01 },
        { image: doctor02 },
        { image: doctor03 },
        { image: doctor04 },
        { image: doctor05 },
    ];
    const sliderRef = useRef(null);
    const [slidePosition, setSlidePosition] = useState(0);
    const items = [feature01, feature02,];
    const numItems = items.length;
    // Custom Arrow Components
    function NextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={`${className} custom-arrow next-arrow`}
                style={{ ...style }}
                onClick={onClick}
            >
                <i className="fas fa-chevron-right"></i>
            </div>
        );
    }

    function PrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={`${className} custom-arrow prev-arrow`}
                style={{ ...style }}
                onClick={onClick}
            >
                <i className="fas fa-chevron-left"></i>
            </div>
        );
    }
    const settings = {
        // dots: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        // autoplay: false,
        infinite: true,
        variableWidth: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        //  arrows: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500, // Adjust as needed

    };
    const doctorSliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    const featureSliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 6,  // Adjust the number of slides to show at once
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        centerMode: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    const facilitiesImages = [
        facility,
        feature6,
        feature3,
        feature4,
    ];

    const facilitiesContentLeft = [
        { icon: faHeartPulse, text: "CATH Lab/CCU/ ICU/NICU" },
        { icon: faStethoscope, text: "Latest Sonography (3D/4D) / 2D ECHO" },
        { icon: faBaby, text: "Advance Fetal Scanning" },
        { icon: faBell, text: "24X7 Emergency/Laboratory" },
    ];

    const facilitiesContentRight = [
        { icon: faHeart, text: "TMT/CT Scan/Dialysis" },
        { icon: faUserShield, text: "Complete Health Checkup/Cancer Screening" },
        { icon: faBuilding, text: "Modular OT Complex" },
        { icon: faCapsules, text: "24X7 Pharmacy" },
    ];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500, // Adjust as needed
        arrows: false, // Hide arrows
    };


    const handlePrev = () => {
        setSlidePosition((prevPosition) => {
            const newPosition = prevPosition + 1;
            return newPosition >= 0 ? 0 : newPosition;
        });
    };
    const handleNext = () => {
        setSlidePosition((prevPosition) => {
            const newPosition = prevPosition - 1;
            const maxPosition = -(numItems - 1);
            return newPosition <= maxPosition ? maxPosition : newPosition;
        });
    };

    // State for doctors
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredDoctors, setFilteredDoctors] = useState([]);
    const [doctors, setDoctors] = useState([]);
    useEffect(() => {
        // Fetch doctor data from your backend API
        axios.get(`${API_BASE_URL}/api/doctor`) // Adjust the URL if needed
            .then(response => {
                setDoctors(response.data); // Assuming the backend returns an array of doctor data
            })
            .catch(error => {
                console.error('There was an error fetching the doctor data!', error);
            });
    }, []);

    // Filter doctors dynamically based on search input (by name or specialty)
    useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredDoctors(doctors);
        } else {
            const filtered = doctors.filter(
                (doctor) =>
                    doctor.name?.toLowerCase().includes(searchTerm.toLowerCase()) || // Search by name
                    doctor.speciality?.toLowerCase().includes(searchTerm.toLowerCase()) // Search by specialty
            );
            setFilteredDoctors(filtered);
        }
    }, [searchTerm, doctors]);

  
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // --- This is the new part: Dynamic Style Generation ---
    const generateKeyframes = (imageCount) => {
        if (imageCount <= 1) return ''; // No animation needed for 0 or 1 image

        const step = 100 / imageCount;
        let keyframes = `@keyframes slideAnimation {\n`;
        
        for (let i = 0; i < imageCount; i++) {
            // Each slide gets an equal amount of time.
            // We define the start and end point for each slide's visibility.
            const startTime = step * i;
            const endTime = step * (i + 1) - 5; // -5 to create a pause on the image
            const nextTime = step * (i + 1);

            keyframes += `  ${startTime}% { transform: translateX(-${i * 100}%); }\n`;
            keyframes += `  ${endTime}% { transform: translateX(-${i * 100}%); }\n`;
            if (i === imageCount - 1) {
                // For the last image, don't add a transition to the next non-existent slide
                // The loop will handle returning to the start.
                 keyframes += `  100% { transform: translateX(-${i * 100}%); }\n`;
            }
        }
        
        // A slightly different approach for a smoother continuous scroll
        keyframes = `@keyframes slideAnimation {\n`;
        keyframes += `  0% { margin-left: 0; }\n`;
        keyframes += `  100% { margin-left: -${imageCount * 100}%; }\n`;
        keyframes += `}`;

        return keyframes;
    };
    // --- End of new part ---


    useEffect(() => {
        const fetchCarouselImages = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${API_BASE_URL}/carousel-images`);
                if (Array.isArray(response.data)) {
                    setImages(response.data);
                    setError('');
                } else {
                    setError('Backend returned data in an unexpected format.');
                    setImages([]);
                }
            } catch (err) {
                setError('Error fetching carousel images: ' + err.message);
                setImages([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCarouselImages();
    }, []);

    if (loading) return <p>Loading slider...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    // Don't render the slider if there are no images
    if (images.length === 0) {
        return <p>No images to display.</p>;
    }

    // --- Clone the images for a seamless loop ---
    const slidesToRender = [...images, ...images];
    // if (loading) {
    //     return <div>Loading carousel images...</div>;
    // }

    // if (error) {
    //     return <div>Error: {error}</div>;
    // }
     const getTodaysSchedule = (doc) => {
        if (!doc) return []; // Guard against null/undefined doctor object
        const todayKey = new Date().toISOString().split('T')[0]; // Format: 'YYYY-MM-DD'
        return doc.dateOverrides?.[todayKey] ?? doc.defaultAvailability ?? [];
    };
    
const formatTime12Hour = (time24) => {
  if (!time24) return 'N/A'; // Handle case where time is not available

  // Split the time string into hours and minutes
  const [hours, minutes] = time24.split(':');

  // Convert hours from string to number
  let hour = parseInt(hours, 10);

  // Determine AM or PM
  const ampm = hour >= 12 ? 'PM' : 'AM';

  // Convert hour to 12-hour format
  hour = hour % 12;
  // If hour is 0 (e.g., 12 AM), it should be 12
  hour = hour ? hour : 12;

  // Return the formatted time string
  return `${hour}:${minutes} ${ampm}`;
};

    return (
        <>
            <div id='zxcv'>
                {/* Header Bar */}

                {/* Header */}
                <header className="contactus-site-header">
                    <Navbar />
                </header>
                {/* Slides Section */}
                <div className="slides">
                    {images.map((imageUrl, index) => (
                        <div className={`slide slide-${index + 1}`} key={index}>
                            <a href='https://www.google.com/maps/place/Hitkari+hospital+%26+surgical+centre/@25.8332524,72.246477,17z/data=!4m18!1m9!3m8!1s0x3943e8d204ffb9b1:0x53a79c16ccad96c!2sHitkari+hospital+%26+surgical+centre!8m2!3d25.8332476!4d72.2490519!9m1!1b1!16s%2Fg%2F11bzth3gsr!3m7!1s0x3943e8d204ffb9b1:0x53a79c16ccad96c!8m2!3d25.8332476!4d72.2490519!9m1!1b1!16s%2Fg%2F11bzth3gsr?entry=ttu&g_ep=EgoyMDI1MDcwOS4wIKXMDSoASAFQAw%3D%3D'>
                            <img
                                src={`${API_BASE_URL}${imageUrl.path}`} alt={`Slide ${index + 1}`} />
                        </a>
                        </div>
                    ))}
                </div>



                {/* popular section  */}
                <section className="home-doc-section">
            <div className="home-doc-container">
                <div className="home-doc-grid">
                    
                    {/* Left Column: Information */}
                    <div className="home-doc-info-col">
                        <div className="home-doc-header">
                            <span className="home-doc-subtitle">Meet Our Experts</span>
                            <h2>Book Our Doctor</h2>
                            <p>Your Wellness, Our Commitment – Book Your Doctor Today!</p>
                        </div>
                        <div className="home-doc-about-content">
                            <p>Discover compassionate care from our dedicated team. With advanced expertise and a patient-first approach, we ensure your journey to better health is smooth and stress-free.</p>
                            <a href="/listdoctor" className="home-doc-btn home-doc-cta-btn">View All Specialists</a>
                        </div>
                    </div>
                    
                    {/* Right Column: Doctor Slider */}
                    <div className="home-doc-slider-col">
                        <Slider {...doctorSliderSettings}>
                                {doctors.map((doctor) => {
                                    // --- FIX: Logic is now INSIDE the map, where 'doctor' is defined ---
                                    const todaysSchedule = getTodaysSchedule(doctor);
                                    const availableSlots = todaysSchedule.filter(slot => slot.isAvailable);

                                    return (
                                        <div className="home-doc-slide-item" key={doctor.doctorId}>
                                            <div className="home-doc-card">
                                                <div className="home-doc-card-header">
                                                    <a href={`/doctor-profile/${doctor.doctorId}`} className="home-doc-card-img-link">
                                                        <img 
                                                            className="home-doc-card-img" 
                                                            src={`${API_BASE_URL}/doctor/${doctor.image}`} 
                                                            alt={doctor.name} 
                                                        />
                                                    </a>
                                                    <a href="/" className="home-doc-fav-btn"><FaBookmark /></a>
                                                </div>
                                                <div className="home-doc-card-body">
                                                    <h3 className="home-doc-title">
                                                        <a href={`/doctor-profile/${doctor.doctorId}`}>{doctor.name}</a>
                                                        <FaCheckCircle className="home-doc-verified-icon" title="Verified" />
                                                    </h3>
                                                    <p className="home-doc-speciality">{doctor.speciality}</p>
                                                    
                                                    <ul className="home-doc-meta-list">
                                                        <li><FaMapMarkerAlt /> {doctor.address}</li>
                                                        <li>
                                                            <FaClock />
                                                             
                                                            <div className="home-doc-timings-container">
                                                                {availableSlots.length > 0 ? (
                                                                    availableSlots.map((slot, idx) => (
                                                                        <span key={idx} className="home-doc-timing-slot" style={{ color: "#757575" }}>
                                                                          
                                                                            {formatTime12Hour(slot.startTime)} - {formatTime12Hour(slot.endTime)}
                                                                        </span>
                                                                    ))
                                                                ) : (
                                                                    <span className="timming" style={{ color: "#757575" }}>Not Available Today</span>
                                                                )}
                                                            </div>
                                                        </li>
                                                        <li><FaRupeeSign /> {doctor.price} Consultation Fee</li>
                                                    </ul>
                                                </div>
                                                <div className="home-doc-card-footer">
                                                    <a href={`/doctor-profile/${doctor.doctorId}`} className="btn view-btn view-profile-hover">View Profile</a>
                                                    <a href={`/patientlogin/${doctor.doctorId}`} className="btn book-btn book-now-hover">Book Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </Slider>
                    </div>
                </div>
            </div>
        </section>
                {/* popular section end */}
            


                {/* Hospital and Specialities Section */}

                <section className="section section-specialities">
                    <div className="container-fluid">
                        <div className="section-header text-center">
                            <h2>Specialities</h2>
                            <p className="sub-title">
                                Explore our advanced Hospital and specialized care at Hitkari Hospital, where innovation and expertise redefine your healthcare experience.
                            </p>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-9">
                                <Slider {...settings} className="specialities-slider">

                                    <div className="speicality-item text-center">
                                        <a href="urology">
                                            <div className="speicality-img">
                                                <img src={speciality01} className="img-fluid" alt="Urology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Urology</p>
                                    </div>
                                    <div className="speicality-item text-center">
                                        <a href="neurology">
                                            <div className="speicality-img">
                                                <img src={speciality02} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Neurology</p>
                                    </div>
                                    <div className="speicality-item text-center">
                                        <a href="orthopedic">
                                            <div className="speicality-img">
                                                <img src={speciality03} className="img-fluid" alt="Orthopedic" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Orthopedic</p>
                                    </div>
                                    {/* <div className="speicality-item text-center">
                                        <a href="cardiology">
                                            <div className="speicality-img">
                                                <img src={speciality04} className="img-fluid" alt="Cardiology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Cardiology</p>
                                    </div> */}
                                    {/* <div className="speicality-item text-center">
                                        <a href="dental">
                                            <div className="speicality-img">
                                                <img src={speciality05} className="img-fluid" alt="Dental" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Dental</p>
                                    </div> */}
                                    <div className="speicality-item text-center">
                                        <a href="emergency">
                                            <div className="speicality-img">
                                                <img src={speciality06} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Emergency</p>
                                    </div>
                                    <div className="speicality-item text-center">
                                        <a href="ent">
                                            <div className="speicality-img">
                                                <img src={speciality07} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>ENT</p>
                                    </div>
                                    {/* <div className="speicality-item text-center">
                                        <a href="hepatology">
                                            <div className="speicality-img">
                                                <img src={speciality08} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Hepatology</p>
                                    </div> */}
                                    <div className="speicality-item text-center">
                                        <a href="icu">
                                            <div className="speicality-img">
                                                <img src={speciality09} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>ICU</p>
                                    </div>
                                    <div className="speicality-item text-center">
                                        <a href="lap">
                                            <div className="speicality-img">
                                                <img src={speciality10} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Laproscopy</p>
                                    </div>
                                    <div className="speicality-item text-center">
                                        <a href="onco">
                                            <div className="speicality-img">
                                                <img src={speciality11} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Oncology</p>
                                    </div>
                                    <div className="speicality-item text-center">
                                        <a href="ped">
                                            <div className="speicality-img">
                                                <img src={speciality12} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Pediatric</p>
                                    </div>
                                    {/* <div className="speicality-item text-center">
                                        <a href="phy">
                                            <div className="speicality-img">
                                                <img src={speciality13} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Physio</p>
                                    </div> */}
                                    {/* <div className="speicality-item text-center">
                                        <a href="psy">
                                            <div className="speicality-img">
                                                <img src={speciality14} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Psychiatry</p>
                                    </div> */}
                                    {/* <div className="speicality-item text-center">
                                        <a href="skin">
                                            <div className="speicality-img">
                                                <img src={speciality15} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Skin</p>
                                    </div> */}
                                    <div className="speicality-item text-center">
                                        <a href="women">
                                            <div className="speicality-img">
                                                <img src={speciality16} className="img-fluid" alt="Neurology" />
                                                <span><i className="fa fa-circle" aria-hidden="true"></i></span>
                                            </div>
                                        </a>
                                        <p>Women</p>
                                    </div>

                                </Slider>

                            </div>
                        </div>
                    </div>
                </section>
                    {/* Home Banner Section */}
                <section className="section section-search">
                    <div className="container-fluid">
                        <div className="banner-wrapper">
                            <div className="banner-header text-center">
                                <h1>Search Doctor, Make an Appointment</h1>
                                <p>
                                    Find the best doctors, book appointments, and access top-notch
                                    care—only at Hitkari Hospital, your trusted healthcare partner.
                                </p>
                            </div>

                            {/* Search */}
                            <div className="search-box">
                                <form action="/">
                                    <div className="form-group search-info">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Doctors, Specialties, etc."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        {/* Search Results */}
                                        {searchTerm && (
                                            <div className="search-results">
                                                {filteredDoctors.length > 0 ? (
                                                    <ul className="list-group mt-2">
                                                        {filteredDoctors.map((doctor) => (
                                                            <li key={doctor._id} className="list-group-item">
                                                                <Link
                                                                    to={`/doctor-profile/${doctor.doctorId}`} // Navigate to doctor's profile
                                                                    className="doctor-link"
                                                                >
                                                                    {doctor.name ?? "Unknown"} - {doctor.speciality ?? "Not Specified"}
                                                                </Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <p className="text-center mt-2">No doctors found.</p>
                                                )}
                                            </div>
                                        )}
                                        <span className="form-text">
                                            Ex : Dental or Heart Check up etc
                                        </span>
                                    </div>
                                    <button type="submit" className="btn btn-primary search-btn">
                                        <i className="fas fa-search"></i> <span>Search</span>
                                    </button>
                                </form>
                            </div>
                            {/* /Search */}
                        </div>
                    </div>
                </section>
               <AvailableFeatures/>
                {/* end  */}


                {/* Facility */}
                {/* <div className="hitkari-facilities-section">
  <div className="hitkari-facilities-container">
    <div className="hitkari-facilities-header">
      <h3 className="hitkari-facilities-title">Our Facilities</h3>
      <h2 className="hitkari-facilities-subtitle">
        Available Facilities at Hitkari Hospital
      </h2>
    </div>

    <div className="hitkari-facilities-content-wrapper">
      <div className="hitkari-facilities-content-left">
        {facilitiesContentLeft.map((item, index) => (
          <div className="hitkari-facility-item" key={index}>
            <FontAwesomeIcon icon={item.icon} className="hitkari-facility-icon" />
            <p>{item.text}</p>
          </div>
        ))}
      </div>

      <div className="hitkari-facilities-slider">
        <Slider {...sliderSettings}>
          {facilitiesImages.map((image, index) => (
            <div key={index}>
              <img
                src={image}
                alt={`Facility ${index + 1}`}
                className="hitkari-facilities-slide-image"
              />
            </div>
          ))}
        </Slider>
      </div>

      <div className="hitkari-facilities-content-right">
        {facilitiesContentRight.map((item, index) => (
          <div className="hitkari-facility-item" key={index}>
            <FontAwesomeIcon icon={item.icon} className="hitkari-facility-icon" />
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
</div> */}
                {/* Facility end */}
                <NABH/>
                <div className="award-container">
                    <div className="section-header">
                        <h2>EMPANALMENTS & TPA</h2>
                    </div>
                    <br />
                    <div className="award-grid">
                        {awardsData.map((award, index) => (
                            <div key={index} className="award-card">
                                <img src={award.img} alt={award.name} className="award-icon" />
                                <p className="award-name">{award.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="section-header">
                        <h2>Gallery</h2>
                    </div>
<HomeGallery/>
                {/* Meet our team */}
                {/* <section className="team-section">
                    <div className="section-header">
                        <h2>Meet Our Team</h2>
                        <p>Experienced doctors, medical professionals and dedicated staff</p>
                    </div>
                    <div className="team-members">
                        {doctors.map((doctor) => (
                            <div className="team-member" key={doctor.doctorId}>
                                <div>
                                    <img src={`${API_BASE_URL}/doctor/${doctor.image}`} alt={doctor.name} />
                                </div>
                                <h4>  <a href={`/doctor-profile/${doctor.doctorId}`}>{doctor.name}</a></h4>
                                <p>{doctor.speciality}</p>
                            </div>
                        ))}
                    </div>
                </section> */}
                {/* Meet our team end */}
            </div>
            <Reviews/>
               <AchievementsSection/>
            <Footer />
        </>
    );
};

export default Header;